// Map balances response V2
export default function mapUsageBalanceV2(response) {
    const getUsageType = key => {
        switch (key) {
            case 'Data':
                return 'data'
            case 'Mins':
                return 'voice'
            case 'IDDMins':
                return 'idd_voice'
            case 'TXTs':
                return 'sms'
            case 'IDDTXTs':
                return 'idd_sms'
            case 'PXTs':
                return 'mms'
            case 'TetheringData':
                return 'tetheringData'
            default:
                return 'unknown'
        }
    }

    // Map aggregated usage
    const aggregated = Object.keys(response)
        .filter(key => key !== 'Products' && key !== 'ProductType')
        .map(key => {
            const usageData = response[key]

            return {
                UsageType: getUsageType(key),
                UsageRule: usageData?.UsageRule || '',
                Total: usageData?.Total || 0,
                AmountRemaining: usageData?.RemainingAmount || 0,
                CarryOverAmount: usageData?.CarryOverAmount || 0,
            }
        })

    // Map per-product breakdown with validation
    const products = (response.Products || [])
        .map(product => {
            // Validate product exists and has minimum required fields
            if (!product || !product.PlanName) {
                console.warn('Invalid product in V2 response:', product)
                return null
            }

            // Helper to safely extract usage data with defaults
            const safeUsageData = (usageObj) => ({
                total: typeof usageObj?.Total === 'number' ? usageObj.Total : 0,
                remaining: typeof usageObj?.RemainingAmount === 'number' ? usageObj.RemainingAmount : 0,
                carry_over: typeof usageObj?.CarryOverAmount === 'number' ? usageObj.CarryOverAmount : 0,
                usage_rule: usageObj?.UsageRule || 'Inactive',
            })

            return {
                plan_name: product.PlanName || '',
                availability_uuid: product.AvailabilityUUID || '',
                product_instance_uuid: product.ProductInstanceUUID || '',
                product_instance_uuids: Array.isArray(product.ProductInstanceUUIDs) ? product.ProductInstanceUUIDs : [],
                product_type: product.ProductType || 'travelMobileAddon',
                is_base_plan: product.IsBasePlan || false,
                status: product.State || 'PREACTIVE',
                country_list: product.CountryList || '',
                regions: Array.isArray(product.Regions) ? product.Regions : [],
                cycle_starts: typeof product.CycleStartsAtNanos === 'number' ? product.CycleStartsAtNanos : 0,
                cycle_ends: typeof product.CycleEndsAtNanos === 'number' ? product.CycleEndsAtNanos : 0,

                data: safeUsageData(product.Data),
                voice: safeUsageData(product.Mins),
                sms: safeUsageData(product.TXTs),
                mms: safeUsageData(product.PXTs),
                idd_voice: safeUsageData(product.IDDMins),
                idd_sms: safeUsageData(product.IDDTXTs),
            }
        })
        .filter(Boolean) // Remove any null entries from invalid products

    return {
        product_type: response.ProductType || 'mobile',
        aggregated,
        products,
    }
}
